import * as PIXI from "pixi.js";
import gsap from "gsap";
import ServiceLocator from "../../ServiceLocator";

import Card from "./Card";
import { Signal } from "signals";
import Spinner from "./Spinner";
import Utils from "../../Utils";
import RadialSpinner from "./RadialSpinner";
import GSAvatarLoader from "../../lib/GSAvatarLoader";


export default class Player extends PIXI.Container
{
    private _id: number = null;
    private _name: string = null;
    private _portraitUrl: string = null;
    private _side: game_side_type = null;

    private _spinner: RadialSpinner = null;
    private _portraitWrapper: PIXI.Container = null;
    private _portrait: PIXI.Container = null;
    private _scoreSprite: PIXI.Sprite = null;
    private _scoreText: PIXI.Text = null;
    private _nameText: PIXI.Text = null;
    private _arrow: PIXI.Sprite = null;

    private _handWrapper: PIXI.Container = null;
    //private _shadowLayer: PIXI.Container = null;
    private _handLayer: PIXI.Container = null;
    private _arrCard: Array<Card> = null;

    private _nextPlayer: Player = null;
    private _prevPlayer: Player = null;

    private _isBot: boolean = null;
    private _isAway: boolean = null;

    private _arrowTl: gsap.core.Timeline = null;

    private _disabledFilter: PIXI.Filter = null;

    private _characterSprite: PIXI.Sprite = null;
    private _characterScale: number = null;

    private _onTurnAnimCompleted: Signal = null;

    private readonly _kPortraitWidth: number = 116;


    public set id( value: number ) { this._id = value; }
    public set name( value: string ) { this._name = value; }
    public set portraitUrl( value: string ) { this._portraitUrl = value; }
    public set side( value: game_side_type ) { this._side = value; }
    public set nextPlayer( value: Player ) { this._nextPlayer = value; }
    public set prevPlayer( value: Player ) { this._prevPlayer = value; }
    public set isBot( value: boolean ) { this._isBot = value; }
    public set isAway( value: boolean ) { this._isAway = value; }

    public get id(): number { return this._id; }
    public get name(): string { return this._name; }
    public get side(): game_side_type { return this._side; }
    public get portraitWrapper(): PIXI.Container { return this._portraitWrapper; }
    public get hand(): Array<Card> { return this._arrCard; }
    public get portraitGlobalPos(): PIXI.Point { return this._portrait.getGlobalPosition(); }
    public get handPos(): PIXI.Point { return this._handWrapper.position; }
    public get nextPlayer(): Player { return this._nextPlayer; }
    public get prevPlayer(): Player { return this._prevPlayer; }
    public get isBot(): boolean { return this._isBot; }
    public get isAway(): boolean { return this._isAway; }

    public get onTurnAnimCompleted(): Signal { return this._onTurnAnimCompleted; }


    public constructor()
    {
        super();
    }

    public init(): void
    {
        console.assert( this._id !== null, "Player.ts :: init() :: this._id cannot be null." );
        console.assert( this._name != null, "Player.ts :: init() :: this._name cannot be null." );
        console.assert( this._portraitUrl != null, "Player.ts :: init() :: this._portraitUrl cannot be null." );
        console.assert( this._side != null, "Player.ts :: init() :: this._side cannot be null." );
        console.assert( this._isBot != null, "Player.ts :: init() :: this._isBot cannot be null." );
          
        this._onTurnAnimCompleted = new Signal();

        this._isAway = false;
        this._arrCard = [];
        this._characterScale = 1;

        this._portraitWrapper = new PIXI.Container();
        this.addChild( this._portraitWrapper );
        //
        this._nameText = new PIXI.Text( this._name, { fontFamily: "asap_bold", fontSize: 30, fill: 0x474747, stroke: 0xffffff, strokeThickness: 6, lineJoin: "round" } );
        this._nameText.anchor.x = 0.5;
        this._nameText.y = 74;
        this._portraitWrapper.addChild( this._nameText );
        //
        Utils.fitTextToWidth( this._nameText, this._side == game_side_type.NORTH || this._side == game_side_type.SOUTH ? 400 : 120 );
        //
        this._portrait = new PIXI.Container();
        this._portraitWrapper.addChild( this._portrait );
        // //
        this._characterSprite = new PIXI.Sprite();
        this._characterSprite.name = "character";
        GSAvatarLoader.i.load( 
            this._portraitUrl, 
            ( texture: PIXI.Texture ) => {
                try
                {
                    this._characterSprite.texture = texture;
                    this._characterScale = this._kPortraitWidth/this._characterSprite.texture.width;
                    this._characterSprite.scale.set( this._characterScale ); 
                    this._characterSprite.y = this._characterSprite.height * 0.5;
                }
                catch( ex ) {}
            } );
        this._characterSprite.anchor.set( 0.5, 1 );
        this._portrait.addChild( this._characterSprite );
        //
        this._spinner = new RadialSpinner();
        this._spinner.innerRadius = this._kPortraitWidth * 0.5;
        this._spinner.outerRadius = this._kPortraitWidth * 0.5 + 10;
        this._spinner.colors = [ 0xffd21f, 0xff0000 ];
        this._spinner.init();
        this._portraitWrapper.addChild( this._spinner );
        
        this._scoreSprite = new PIXI.Sprite( ServiceLocator.resources.score_counter.texture );
        this._scoreSprite.visible = false;
        this._scoreSprite.name = "score";
        this._scoreSprite.anchor.set( 0.5 );
        this._scoreSprite.position.set( 430, 802 );
        this.addChild( this._scoreSprite );
        //
        this._scoreText = new PIXI.Text( "0", { fill: "white", fontSize: 38, fontFamily: "asap_bold" } );
        this._scoreText.anchor.set( 0.5 );
        this._scoreSprite.addChild( this._scoreText );
        
        this._arrow = new PIXI.Sprite( ServiceLocator.resources.player_arrow.texture );
        this._arrow.anchor.set( 0.5, 1 );
        this._arrow.visible = false;
        this._arrow.position.y = -70;
        this._portraitWrapper.addChild( this._arrow );
        //
        this._arrowTl = new gsap.core.Timeline();
        this._arrowTl.to( this._arrow, { y: "+=4", duration: 0.6, repeat: -1, yoyo: true, ease: "sine.inOut" }, 0 );
        ServiceLocator.game.tweenGroup.add( this._arrowTl );
        this._arrowTl.pause( 0 );

        this._handWrapper = new PIXI.Container();
        if ( this._side == game_side_type.SOUTH )
        {
            this.addChild( this._handWrapper );
        }
        else
        {
            this.addChildAt( this._handWrapper, 0 );
        }
        //
        /*this._shadowLayer = new PIXI.Container();
        this._shadowLayer.y = 30;
        this._handWrapper.addChild( this._shadowLayer );*/
        //
        this._handLayer = new PIXI.Container();
        this._handLayer.y = 30;
        this._handWrapper.addChild( this._handLayer );

        switch ( this._side )
        {
            case game_side_type.NORTH: 
                { 
                    this._portraitWrapper.position.set( 319, 131 );
                    this._handWrapper.angle = -180;
                    this._handWrapper.position.set( 320, -10 );
                    break; 
                }
            
            case game_side_type.EAST: 
                { 
                    this._portraitWrapper.position.set( 509, 308 );
                    this._handWrapper.angle = -90;
                    this._handWrapper.position.set( 640, 572 );
                    break; 
                }
            
            case game_side_type.SOUTH: 
                { 
                    this._portraitWrapper.position.set( 319, 786 );
                    this._handWrapper.position.set( 320, 978 );
                    break 
                }

            case game_side_type.WEST: 
                { 
                    this._portraitWrapper.position.set( 121, 308 );
                    this._handWrapper.angle = 90;
                    this._handWrapper.position.set( 0, 572 );
                    break; 
                }
        }

        this._disabledFilter = new PIXI.filters.ColorMatrixFilter();
        ( this._disabledFilter as any ).brightness( 0.8, false );
        this._disabledFilter.enabled = false;
        this._disabledFilter.resolution = 8;
        this.filters = [ this._disabledFilter ];
    }

    public end(): void
    {
        this._onTurnAnimCompleted.dispose();
        this._onTurnAnimCompleted = null;

        this._arrowTl.kill();
        this._arrowTl = null;

        this._spinner.end();
        this._spinner = null;
    }

    public addCard( card: Card ): void
    {
        card.owner = this;
        card.alpha = 1;

        this._arrCard.push( card );
    }

    public removeCard( removedCard: Card ): void
    {
        this._arrCard.splice( this._arrCard.indexOf( removedCard ), 1 );
        this._handLayer.removeChild( removedCard.parent );
        //this._shadowLayer.removeChild( ( removedCard.parent as any )._shadowWrapper );

        if ( this._handLayer.children.length > 0 )
        {
            const kHandSize: number = this._arrCard.length;
            const kHandWidthMult: number = this._side == game_side_type.SOUTH ? 0.9 : 0.5;
            const kCardMargin: number = Math.min( ServiceLocator.app.width * kHandWidthMult / kHandSize, 133 * kHandWidthMult );
            
            const kArcRadius: number = this._side == game_side_type.SOUTH ? 4200 : 700;
            const L: number = kCardMargin * ( kHandSize % 2 == 0 ? kHandSize : kHandSize - 1 );   // longitud del arco
            const R: number = kArcRadius; // radio de la circunferencia
            //
            const theta: number = L / R; // en radianes
            const deltaTheta: number = theta / kHandSize;
            let accTheta: number = -theta * 0.5 + deltaTheta * 0.5;
            
            let tl: gsap.core.Timeline = new gsap.core.Timeline();
            //
            for ( let i: number = 0; i < this._handLayer.children.length; ++i )
            {
                let cardWrapper: PIXI.Container = this._handLayer.children[ i ] as PIXI.Container;
                tl.to( cardWrapper, { rotation: accTheta, duration: 0.1 }, 0/*0.02 * i*/ );
                tl.to( ( cardWrapper as any )._shadowWrapper, { rotation: accTheta, duration: 0.1 }, 0/*0.02 * i*/ );

                accTheta += deltaTheta;
            }
            //
            ServiceLocator.game.tweenGroup.add( tl );
        }
    }

    public setHandInteractive( isInteractive: boolean ): void
    {
        for ( let card of this._arrCard )
        {
            card.interactive = isInteractive;
            card.buttonMode = isInteractive;
        }
    }
    
    public playBumpScoreAnim( score: number ): void
    {
        let tl: gsap.core.Timeline = new gsap.core.Timeline();
        tl.to( this._scoreSprite.scale, { x: 1.2, y: 1.2, duration: 0.15, ease: "sine.out" }, 0 );
        tl.call( () => { this._scoreText.text = score.toString(); }, null, 0.15 );
        tl.to( this._scoreSprite.scale, { x: 1, y: 1, duration: 0.15, ease: "sine.out" }, 0.15 );
        //
        ServiceLocator.game.tweenGroup.add( tl );
    }

    public setScore( score: number ): void
    {
        this._scoreText.text = score.toString();
    }

    public setSpinnerProgress( progress: number ): void
    {
        this._spinner.setProgress( progress );
    }

    public hideSpinner(): void
    {
        this._spinner.visible = false;
    }

    public setArrowVisibility( isVisible: boolean ): void
    {
        this._arrow.visible = isVisible;
    }

    public updateCharacter(): void
    {
        this._nameText.text = this._name;
        this._nameText.scale.set( 1 );
        //
        Utils.fitTextToWidth( this._nameText, this._side == game_side_type.NORTH || this._side == game_side_type.SOUTH ? 400 : 120 );

        GSAvatarLoader.i.load( 
            this._portraitUrl, 
            ( texture: PIXI.Texture ) => {
                try
                {
                    this._characterSprite.texture = texture;
                    this._characterScale = this._kPortraitWidth/this._characterSprite.texture.width;
                    this._characterSprite.scale.set( this._characterScale ); 
                    this._characterSprite.y = this._characterSprite.height * 0.5;
                }
                catch( ex ) {}
            } );

        /*this._arrow.y = -70;
        //
        this._arrowTl.clear();
        this._arrowTl.to( this._arrow, { y: "+=8", duration: 0.6, repeat: -1, yoyo: true, ease: "sine.inOut" }, 0 );
        this._arrowTl.pause( 0 );*/
    }

    public setHighlighted( isHighlighted: boolean ): void
    {
        this._spinner.visible = isHighlighted;
        
        this._arrow.visible = isHighlighted;
        this._disabledFilter.enabled = !isHighlighted;

        if ( isHighlighted )
        {
            this._spinner.setProgress( 0 );
            this._arrowTl.play( 0 );
        }
        else
        {
            this._arrowTl.pause( 0 );
        }
    }

    public sortHandFaceDown(): void
    {
        this._layoutCards( [ this._arrCard.slice( 0 ) ] );
        for ( let card of this._arrCard )
        {
            ( card as Card ).setFaceDown();
        }
    }

        private _sortCards( cards: Array<Card> ): Array<Array<Card>>
        {
            let result: Array<Array<Card>> = [ [], [], [], [], [] ];

            for ( let i: number = 0; i < cards.length; ++i )
            {
                let card: Card = cards[ i ];
                let suitIndex: number = card.color;
                if ( suitIndex == 0 )
                {
                    suitIndex = 1;
                }
                else if ( suitIndex == 1 )
                {
                    suitIndex = 0;
                }
                let arrCard: Array<Card> = result[ suitIndex ];
                let cardInsertIndex: number = 0;
                while ( cardInsertIndex < arrCard.length && arrCard[ cardInsertIndex ].value > card.value )
                {
                    ++cardInsertIndex;
                }
                arrCard.splice( cardInsertIndex, 0, card );
            }

            return result;
        }

        private _layoutCards( arrCardList: Array<Array<Card>> ): void
        {
            const kHandSize: number = this._arrCard.length;
            const kHandWidthMult: number = this._side == game_side_type.SOUTH ? 0.9 : 0.5;
            const kCardMargin: number = Math.min( ServiceLocator.app.width * kHandWidthMult / kHandSize, 133 * kHandWidthMult );
            this._handLayer.removeChildren();
            //this._shadowLayer.removeChildren();
            
            const kArcRadius: number = this._side == game_side_type.SOUTH ? 4200 : 700;
            const L: number = kCardMargin * ( kHandSize % 2 == 0 ? kHandSize : kHandSize - 1 );   // longitud del arco
            const R: number = kArcRadius; // radio de la circunferencia
            //
            const theta: number = L / R; // en radianes
            const deltaTheta: number = theta / kHandSize;
            let accTheta: number = -theta * 0.5 + deltaTheta * 0.5;
            for ( let cardList of arrCardList )
            {
                for ( let card of cardList )
                {
                    let cardWrapper: PIXI.Container = new PIXI.Container();
                    cardWrapper.y = kArcRadius;
                    cardWrapper.rotation = accTheta;
                    this._handLayer.addChild( cardWrapper );
                    //
                    card.x = 0;
                    card.y = -kArcRadius;
                    card.rotation = 0;
                    cardWrapper.addChild( card );

                    /*let shadowWrapper: PIXI.Container =new PIXI.Container();
                    shadowWrapper.y = cardWrapper.y;
                    shadowWrapper.rotation = cardWrapper.rotation;
                    this._shadowLayer.addChild( shadowWrapper );
                    //
                    let shadow: PIXI.Sprite = new PIXI.Sprite( ServiceLocator.resources.deck_shadow.texture );
                    shadow.anchor.set( 0.5 );
                    shadow.x = card.x - 10;
                    shadow.y = card.y - 10;
                    shadow.rotation = card.rotation;
                    shadowWrapper.addChild( shadow );
                    //
                    ( cardWrapper as any )._shadowWrapper = shadowWrapper;*/

                    accTheta += deltaTheta;
                }
            }
        }

    public sortHandFaceUp(): void
    {
        let arrCardList: Array<Array<Card>> = this._sortCards( this._arrCard );
        this._layoutCards( arrCardList );
        for ( let card of this._arrCard )
        {
            ( card as Card ).setFaceUp();
        }
    }

    public findGlobalHandLayout( cardCount: number ): Array<ICardLayout>
    {
        let result: Array<ICardLayout> = [];

        const kHandWidthMult: number = this._side == game_side_type.SOUTH ? 0.9 : 0.5;
        const kCardMargin: number = Math.min( ServiceLocator.app.width * kHandWidthMult / cardCount, 133 * kHandWidthMult );
        this._handLayer.removeChildren();
        
        const kArcRadius: number = this._side == game_side_type.SOUTH ? 4200 : 700;
        const L: number = kCardMargin * ( cardCount % 2 == 0 ? cardCount : cardCount - 1 );   // longitud del arco
        const R: number = kArcRadius; // radio de la circunferencia
        //
        const theta: number = L / R; // en radianes
        const deltaTheta: number = theta / cardCount;
        let accTheta: number = -theta * 0.5 + deltaTheta * 0.5;
        for ( let i: number = 0; i < cardCount; ++i )
        {
            let dummyCardWrapper: PIXI.Container = new PIXI.Container();
            dummyCardWrapper.y = kArcRadius;
            dummyCardWrapper.rotation = accTheta;
            this._handLayer.addChild( dummyCardWrapper );

            let dummyCard: PIXI.Container = new PIXI.Container();
            dummyCard.x = 0;
            dummyCard.y = -kArcRadius;
            dummyCardWrapper.addChild( dummyCard );

            result.push( { 
                x: dummyCard.getGlobalPosition().x, 
                y: dummyCard.getGlobalPosition().y, 
                rotation: dummyCard.parent.rotation + [ 0, Math.PI * 0.5, 0, -Math.PI * 0.5 ][ this._side ] } );

            accTheta += deltaTheta;
        }

        this._handLayer.removeChildren();

        return result;
    }

    public onDeckEntryAnimationStarted( isFirstRound: boolean ): void
    {
        this._disabledFilter.enabled = false;
        this._scoreSprite.visible = false;
        if ( isFirstRound )
        {
            this._portraitWrapper.scale.set( 0 );
        }
    }

    public onDeckEntryAnimationEnded(): void
    {
        this._disabledFilter.enabled = true;
        this._scoreSprite.visible = this._side == game_side_type.SOUTH/* && Session.i.gameType == game_type.MATCHMAKING*/;
    }

    public onTurnStarted(): void
    {
        let tl: gsap.core.Timeline = new gsap.core.Timeline();
        tl.to( this._characterSprite.scale, { y: this._characterScale * 0.6, duration: 0.1, ease: "sine.out" }, 0 );
        tl.to( this._characterSprite, { y: "-=70", duration: 0.2, ease: "sine.out" }, 0.1 );
        tl.to( this._characterSprite.scale, { x: this._characterScale * 0.6, y: this._characterScale, duration: 0.2, ease: "sine.out" }, 0.1 );
        tl.to( this._characterSprite, { y: "+=70", duration: 0.2, ease: "sine.out" }, 0.3 );
        tl.to( this._characterSprite.scale, { x: this._characterScale, y: this._characterScale * 0.6, duration: 0.2, ease: "sine.out" }, 0.3 );
        tl.to( this._characterSprite.scale, { y: this._characterScale, duration: 0.1, ease: "sine.out" }, 0.5 );
        tl.call( () => { this._onTurnAnimCompleted.dispatch( this ); }, null, ">" );
        //
        ServiceLocator.game.tweenGroup.add( tl );
    }

    public findPostDrawAnimGlobalHandLayout( arrDrawnCard: Array<Card> ): Array<ICardLayout>
    {
        let result: Array<ICardLayout> = new Array<ICardLayout>();

        let arrTargetCardWrapperInfo: Array<ITargetCardWrapper> = this._findPostDrawAnimCardWrapperInfo( arrDrawnCard );    

        let cardWrapperIndex: number = 0;
        let targetCardWrapperIndex: number = 0;
        //
        while ( cardWrapperIndex < this._handLayer.children.length )
        {
            let cardWrapper: PIXI.Container = this._handLayer.children[ cardWrapperIndex ] as PIXI.Container;
            let targetCardWrapperInfo: ITargetCardWrapper = arrTargetCardWrapperInfo[ targetCardWrapperIndex ];
            if ( cardWrapper.children[ 0 ] as Card == targetCardWrapperInfo.card )
            {
                const kRotationAux: number = cardWrapper.rotation;
                cardWrapper.rotation = targetCardWrapperInfo.rotation;
                const kCard: Card = cardWrapper.children[ 0 ] as Card;
                result.push( {
                    x: kCard.getGlobalPosition().x, 
                    y: kCard.getGlobalPosition().y, 
                    rotation: targetCardWrapperInfo.rotation + [ 0, Math.PI * 0.5, 0, -Math.PI * 0.5 ][ this._side ],
                    card: kCard } );
                cardWrapper.rotation = kRotationAux;

                //tl.to( cardWrapper, { rotation: targetCardWrapperInfo.rotation, duration: 0.1 }, "<" );

                cardWrapperIndex += 1;
            }
            else
            {
                let dummyCardWrapper: PIXI.Container = new PIXI.Container();
                dummyCardWrapper.y = targetCardWrapperInfo.radius;
                dummyCardWrapper.rotation = targetCardWrapperInfo.rotation;
                this._handLayer.addChild( dummyCardWrapper );

                let dummyCard: PIXI.Container = new PIXI.Container();
                dummyCard.x = 0;
                dummyCard.y = -targetCardWrapperInfo.radius;
                dummyCardWrapper.addChild( dummyCard );

                result.push( { 
                    x: dummyCard.getGlobalPosition().x, 
                    y: dummyCard.getGlobalPosition().y, 
                    rotation: dummyCard.parent.rotation + [ 0, Math.PI * 0.5, Math.PI, -Math.PI * 0.5 ][ this._side ],
                    card: targetCardWrapperInfo.card } );

                this._handLayer.removeChild( dummyCardWrapper );
            }

            targetCardWrapperIndex += 1;
        }
        //
        while ( targetCardWrapperIndex < arrTargetCardWrapperInfo.length )
        {
            let targetCardWrapperInfo: ITargetCardWrapper = arrTargetCardWrapperInfo[ targetCardWrapperIndex ];
            let dummyCardWrapper: PIXI.Container = new PIXI.Container();
            dummyCardWrapper.y = targetCardWrapperInfo.radius;
            dummyCardWrapper.rotation = targetCardWrapperInfo.rotation;
            this._handLayer.addChild( dummyCardWrapper );

            let dummyCard: PIXI.Container = new PIXI.Container();
            dummyCard.x = 0;
            dummyCard.y = -targetCardWrapperInfo.radius;
            dummyCardWrapper.addChild( dummyCard );

            result.push( {
                x: dummyCard.getGlobalPosition().x, 
                y: dummyCard.getGlobalPosition().y, 
                rotation: dummyCard.parent.rotation + [ 0, Math.PI * 0.5, Math.PI, -Math.PI * 0.5 ][ this._side ],
                card: targetCardWrapperInfo.card } );

            this._handLayer.removeChild( dummyCardWrapper );

            targetCardWrapperIndex += 1
        }

        return result;
    }

        private _findPostDrawAnimCardWrapperInfo( arrDrawnCard: Array<Card> ): Array<ITargetCardWrapper>
        {
            let result: Array<ITargetCardWrapper> = [];

            let arrTempCard: Array<Card> = this._arrCard.slice( 0 ).concat( arrDrawnCard );
            let arrSortedCard: Array<Array<Card>> = new Array<Array<Card>>();
            if ( this._side == game_side_type.SOUTH )
            {
                arrSortedCard = this._sortCards( arrTempCard );
            }
            else
            {
                arrSortedCard.push( this._arrCard.concat( arrDrawnCard ) );
            }

            const kHandSize: number = arrTempCard.length;
            const kHandWidthMult: number = this._side == game_side_type.SOUTH ? 0.9 : 0.5;
            const kCardMargin: number = Math.min( ServiceLocator.app.width * kHandWidthMult / kHandSize, 133 * kHandWidthMult );
            
            const kArcRadius: number = this._side == game_side_type.SOUTH ? 4200 : 700;
            const L: number = kCardMargin * ( kHandSize % 2 == 0 ? kHandSize : kHandSize - 1 );   // longitud del arco
            const R: number = kArcRadius; // radio de la circunferencia
            //
            const theta: number = L / R; // en radianes
            const deltaTheta: number = theta / kHandSize;
            let accTheta: number = -theta * 0.5 + deltaTheta * 0.5;
            for ( let cardList of arrSortedCard )
            {
                for ( let card of cardList )
                {
                    let targetCardWrapper: ITargetCardWrapper = {
                        card: card,
                        rotation: accTheta,
                        radius: kArcRadius
                    };
                    result.push( targetCardWrapper );

                    accTheta += deltaTheta;
                }
            }

            return result;
        }
}

export const enum game_side_type
{
    SOUTH = 0,
    WEST,
    NORTH,
    EAST,
    kCount
}

export const enum banner_type
{
    IDLE = 0,
    TURN,
    WINNER
}

export interface IPlayerResponsive
{
    portraitWrapper: PIXI.Container;
    handWrapper: PIXI.Container;
}

export interface ICardLayout
{
    x: number;
    y: number;
    rotation: number;
    card?: Card;
}

export interface ITargetCardWrapper
{
    card: Card;
    rotation: number;
    radius: number;
}